<div>
    <div class="form-subsection-container custom-page-row">
        <div class="page-title">
                    <img src="assets/icons/cogs.svg">
                    <div>Asset Management</div>
        </div>
        <div class="action-item">
            <button class="default-custom-button custom-button custom-button-stroked" id="edit" type="submit" (click)="exportDevicesToCSV()">
                <div>
                    Export
                </div>
            </button>
            <button (click)="openDeviceModal()" class="default-custom-button add-button custom-button custom-button-flat">Add Device</button>
        </div>
    </div>

    <div class="page-controls">
        <form [formGroup]="form">
                <div class="free-search page-options custom-page-row">
                    <free-search formControlName = "search" [searchOptions]="searchOptions"></free-search>
                    <button class="primary custom-button custom-button-text" id="edit" type="button" (click)="resetFilters()">
                      Reset Filters
                    </button>
                </div>
                <div class="page-options form-subsection-container small-screen-subsection custom-page-row">
                    <div class="additional-filters">
                        <span>Filters:</span>
                        <synx-dropdown class="customer-dropdown" title="Customer" formControlName="customerId"
                            [selectOptions]="customerOptions" [width]="'158px'" [inputHeight]="'38px'"></synx-dropdown>
                        <span>
                            <label class="switch">
                                <input type="checkbox" formControlName="onlyFilterEnabled">
                                <span class="slider round"></span>
                            </label>
                            <span class="show-only-label">Show Only</span>
                            <synx-dropdown class="default-custom-dropdown" title="Show Only" formControlName="onlyFilter"
                                [selectOptions]="onlyFilterOptions" [width]="'171px'" [inputHeight]="'38px'"></synx-dropdown>
                        </span>
                    </div>
                    <div class="actions">
                        <span class="action-item">
                            <span style="margin-top: 11px;">
                                Actions:
                            </span>
                            <synx-dropdown class="firmware-dropdown" title="Firmware" [selectOptions]="firmwareOptions"
                                [width]="'226px'" [inputHeight]="'39px'"
                                [(ngModel)]="selectedFirmware" [ngModelOptions]="{ standalone: true }"></synx-dropdown>
                            <div class="split-upgrade-button" synxTooltip="Devices can only be upgraded if they are online." synxTooltipCaret="below">
                                <button class="default-custom-button upgrade-firmware-btn split-upgrade-main custom-button custom-button-flat" id="edit" type="button" [disabled]="upgradeDisabled" (click)="upgradeFirmware()">
                                  {{ selectedUpgradeType === 1 ? 'Upgrade on Next Reboot' : 'Upgrade Now' }}
                                </button>
                                <custom-dropdown-list-container class="split-upgrade-caret" [(isDropdownOpen)]="upgradeMenuOpen">
                                    <div dropdown-toggle class="split-upgrade-caret-toggle" [class.split-upgrade-disabled]="upgradeDisabled">
                                        <i class="custom-arrow" [class.down]="!upgradeMenuOpen" [class.up]="upgradeMenuOpen"></i>
                                    </div>
                                    <div dropdown-list class="custom-dropdown-items split-upgrade-options custom-dropdown-light">
                                        <custom-menu-item [name]="'Upgrade on Next Reboot'" (executeEvent)="selectUpgradeType(1)"></custom-menu-item>
                                        <custom-menu-item [name]="'Upgrade Now'" (executeEvent)="selectUpgradeType(0)"></custom-menu-item>
                                    </div>
                                </custom-dropdown-list-container>
                            </div>
                        </span>
                        <div class="custom-separator"></div>
                        <span class="action-item">
                            <custom-menu class="custom-form-field default-custom-dropdown firmware-dropdown device-search" [tooltip]="'Please select a device in order to use actions.'" [menuTitle]="'More Actions'">
                                <custom-menu-item [name]="'Request Logs'" [iconPath]="'assets/icons/log-request.svg'" [disabled]="selectionOutOfRange" (executeEvent)="requestManyLogs()"></custom-menu-item>
                                <custom-menu-item [name]="'Download Logs'" [iconPath]="'assets/icons/download.svg'" [disabled]="downloadDisabled" (executeEvent)="downloadLogs()"></custom-menu-item>
                                <custom-menu-item [name]="'Reset Camera Ref'" [iconPath]="'assets/icons/union.svg'" [disabled]="resetCameraRefDisabled" (executeEvent)="resetManyCameraSnapshotReference()"></custom-menu-item>
                                <custom-menu-item [name]="'Request Ref Images'" [iconPath]="'assets/icons/union.svg'" [disabled]="selectionOutOfRange" (executeEvent)="requestManyCameraSnapshotReference()"></custom-menu-item>
                                <custom-menu-item [name]="'Force Recording Map Upload'" [iconPath]="'assets/icons/progress-upload.svg'" [disabled]="forceRecordingMapDisabled" (executeEvent)="forceRecordingMapUpload()"></custom-menu-item>
                            </custom-menu>
                            <div synxTooltip="Opens a dialog box which allows you to bulk update the selected devices" synxTooltipCaret="below">
                                <button class="default-custom-button log-button custom-button custom-button-stroked" id="edit" type="button" [disabled]="selectionOutOfRange || selectedDevices.length < 2" (click)="openBulkEdit()">
                                    <div>
                                        Bulk Edit
                                    </div>
                                </button>
                            </div>
                        </span>
                        <div class="custom-separator"></div>
                        <span class="action-item">
                            <div synxTooltip="Delete Selected Assets" synxTooltipCaret="below">
                                <button class="default-custom-button delete-button custom-button custom-button-stroked" id="edit" type="button" [disabled]="selectionOutOfRange" (click)="deleteDevices()">
                                    <svg class="custom-button-icon" width="16" height="18" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM3 3H13V16H3V3ZM5 5V14H7V5H5ZM9 5V14H11V5H9Z"/>
                                    </svg>
                                    <div>
                                        Delete
                                    </div>
                                </button>
                            </div>
                        </span>
                    </div>
                </div>
        </form>
    </div>
    <div class="table-actions custom-page-row">
        <div class="device-count-message">{{selectedDevices.length}} Item{{selectedDevices.length > 1 || selectedDevices.length < 1 ? 's' : ''}} Selected</div>
        <div class="custom-separator"></div>
        <button class="primary clear-selection custom-button custom-button-text" id="edit" type="submit" (click)="clearSelection()">
          Clear Selection
        </button>
    </div>

    <span class="ml-2 badge badge-dark d-none d-sm-inline" *ngIf="filtered">Results are being filtered</span>

    <div class="position-relative">
        <div class="loading-shade" *ngIf="isLoadingResults">
            <div class="loading-spinner"></div>
        </div>
        <h5 class="no-results text-center font-weight-bold py-3" *ngIf="resultsLength == 0 && !isLoadingResults">
            No Devices Found
        </h5>
        <div class="table-container device-table-container">
            <table class="custom-table" customSort [class.d-none]="resultsLength == 0" style="width: fit-content">
                <thead>
                    <tr>
                        <th class="select-header frozen-header" synxTooltip="Only the first {{selectedDevicesLimit}} assets in the list will be selected" synxTooltipCaret="below" [style.width]="getColumnWidth('select')">
                            <input type="checkbox" class="table-checkbox" [checked]="selectBatchChecked" (click)="selectBatchToggled($event.target.checked)">
                        </th>
                        <th custom-sort-header="serialNumber" class="first-column serial-no-header frozen-header" [style.width]="getColumnWidth('serialNumber')">{{columnDefinitions.get('serialNumber')?.displayName}}</th>
                        <th class="edit-header frozen-header" [style.width]="getColumnWidth('buttons')"><div>Edit</div></th>
                        <th custom-sort-header="deviceId" synxTooltip="This ID is extracted from the health payload sent from the asset." synxTooltipCaret="below" [style.width]="getColumnWidth('deviceId')">{{columnDefinitions.get('deviceId')?.displayName}}</th>
                        <th custom-sort-header="customer" [style.width]="getColumnWidth('customer')">{{columnDefinitions.get('customer')?.displayName}}</th>
                        <th custom-sort-header="fleetId" [style.width]="getColumnWidth('fleetId')">{{columnDefinitions.get('fleetId')?.displayName}}</th>
                        <th custom-sort-header="online" [style.width]="getColumnWidth('online')">{{columnDefinitions.get('online')?.displayName}}</th>
                        <th custom-sort-header="lastPinged" [style.width]="getColumnWidth('lastPinged')">{{columnDefinitions.get('lastPinged')?.displayName}}</th>
                        <th custom-sort-header="assetType" [style.width]="getColumnWidth('assetType')">{{columnDefinitions.get('assetType')?.displayName}}</th>
                        <th custom-sort-header="assetGroupPath" [style.width]="getColumnWidth('assetGroupPath')">{{columnDefinitions.get('assetGroupPath')?.displayName}}</th>
                        <th custom-sort-header="firmware" [style.width]="getColumnWidth('firmware')">{{columnDefinitions.get('firmware')?.displayName}}</th>
                        <th custom-sort-header="hwVer" [style.width]="getColumnWidth('hwVer')">{{columnDefinitions.get('hwVer')?.displayName}}</th>
                        <th custom-sort-header="sim" [style.width]="getColumnWidth('sim')">{{columnDefinitions.get('sim')?.displayName}}</th>
                        <th custom-sort-header="enabled" [style.width]="getColumnWidth('enabled')">{{columnDefinitions.get('enabled')?.displayName}}</th>
                        <th custom-sort-header="enableRecordingMapRequest" [style.width]="getColumnWidth('enableRecordingMapRequest')">{{columnDefinitions.get('enableRecordingMapRequest')?.displayName}}</th>
                        <th custom-sort-header="enableCamerasSnapshotRequest" [style.width]="getColumnWidth('enableCamerasSnapshotRequest')">{{columnDefinitions.get('enableCamerasSnapshotRequest')?.displayName}}</th>
                        <th custom-sort-header="logsRequest" [style.width]="getColumnWidth('logsRequest')">{{columnDefinitions.get('logsRequest')?.displayName}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let device of devices" [class.highlighted-row]="getDeviceSelected(device.id)">
                        <td class="select-cell frozen-cell" [class.highlighted-row]="getDeviceSelected(device.id)">
                            <input type="checkbox" class="table-checkbox" (click)="toggleSelected(device)" [checked]="getDeviceSelected(device.id)" [disabled]="selectDisabled(device.id)">
                        </td>
                        <td class="first-column serial-no-content serial-no-cell frozen-cell" [class.highlighted-row]="getDeviceSelected(device.id)" [title]="device.serialNumber ?? ''">
                            {{ device.serialNumber }}
                        </td>
                        <td class="edit-cell frozen-cell" [class.highlighted-row]="getDeviceSelected(device.id)">
                            <a (click)="openDeviceModal(device)"> <img class="edit-icon" src="assets/icons/pencil.svg" /></a>
                        </td>
                        <td [title]="device.deviceId ?? ''">
                            {{ device.deviceId }}
                        </td>
                        <td [title]="device?.customer?.name ?? ''">
                            {{ device?.customer?.name }}
                        </td>
                        <td [title]="device.fleetId ?? ''">
                            {{ device.fleetId }}
                        </td>
                        <td>
                            <div class="shift-centered-data">
                                <div *ngIf="device.online;else offline_content" class="cell-content-wrapper"><div class="online custom-badge"></div>Online</div>
                                <ng-template #offline_content>
                                    <div class="cell-content-wrapper"><div class="offline custom-badge"></div>Offline</div>
                                </ng-template>
                            </div>
                        </td>
                        <td class="cell-with-icon">
                            <div>
                                <p>{{ getFormattedDateTimeString(device.lastPinged) }}</p>
                                <custom-tooltip *ngIf="getLastSeenIcon(device.lastPinged) as lastSeenIcon" [tooltipMessage]="getLastSeenTooltip(device.lastPinged)">
                                    <img [src]="lastSeenIcon" alt="last-seen-flag" tooltip-hoverable />
                                </custom-tooltip>
                            </div>
                        </td>
                        <td [title]="device.assetType?.name ?? ''">
                            {{ device.assetType?.name }}
                        </td>
                        <td [title]="device.assetGroupPath ?? ''">
                            {{ device.assetGroupPath }}
                        </td>
                        <td>
                            {{ device.firmware }}
                        </td>
                        <td [title]="device.hwVer ?? ''">
                            {{ device.hwVer }}
                        </td>
                        <td [title]="device.sim ?? ''">
                            {{ device.sim }}
                        </td>
                        <td>
                            <ng-container *ngIf="device.enabled"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="device.enableRecordingMapRequest"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="device.enableCamerasSnapshotRequest"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
                        </td>
                        <td>
                            <div class="cell-content-wrapper" *ngIf="device.logsRequest"
                                 [synxTooltip]="getLogStatusTooltip(device.logsRequest)"
                                 synxTooltipCaret="below">
                                <div class="custom-chip" [class.ready]="getLogStatus(device.logsRequest) === 'Ready'" [class.requested]="getLogStatus(device.logsRequest) === 'Requested...'">
                                    {{getLogStatus(device.logsRequest)}}
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <custom-paginator class="flex-grow-1" [length]="resultsLength" [pageSize]="25"
            [pageSizeOptions]="[5, 10, 25, 100]"></custom-paginator>
    </div>
</div>

<ng-container *ngIf="bulkEditing == true">
    <bulk-edit-device-modal [devices]="selectedDevices" [triggerRefresh]="forceTableRefresh" [customers]="customers"
        (close)="modalClosed()"></bulk-edit-device-modal>
</ng-container>

<ng-container *ngIf="addingDevice == true">
    <device-form-modal [deviceId]="activeDevice?.id" [triggerRefresh]="forceTableRefresh" [customers]="customers"
        (close)="modalClosed()"></device-form-modal>
</ng-container>